import type { MenuType } from "~/types/menu.type";
import { routes } from "~/routes";

export const menuList: MenuType[] = [
  {
    name: "Home",
    icon: "home",
    to: "/",
    key: "HOME",
    featured: [],
  },
  {
    name: "Blockchain",
    icon: "cube",
    activeRegex: /^\/(blocks|transactions|deployed-contracts).*$/,
    key: "BLOCKCHAIN",
    featured: [],
    underItems: [
      {
        name: "Transactions",
        to: routes.getTransactionsPage(),
        key: "TRANSACTIONS",
        featured: [],
      },
      {
        name: "Internal Transactions",
        to: routes.getInternalTransactionsPage(),
        key: "INTERNAL_TRANSACTIONS",
        featured: [],
      },
      {
        name: "Blocks",
        to: routes.getBlockListPage(),
        activeRegex: /^\/blocks.*(block|transactions|internal-transactions)$/,
        key: "BLOCKS",
        featured: [],
      },
      {
        name: "Deployed Contracts",
        to: routes.getDeployedContractsPage(),
        key: "DEPLOYED_CONTRACTS",
        featured: [],
      },
    ],
  },
  {
    name: "Tokens",
    icon: "coins",
    activeRegex: /^\/tokens\/.*$/,
    to: routes.getTokensPage(),
    key: "TOKENS",
    featured: [],
  },
  {
    name: "NFTs",
    icon: "images",
    activeRegex: /^\/nfts\/.*$/,
    key: "NFTS",
    featured: [],
    underItems: [
      {
        name: "All NFTs & Transfers",
        to: routes.getLatestTransfersPage(),
        key: "NFT_TRANSFERS",
        featured: [],
      },
      {
        name: "NFT Trades",
        to: routes.getLatestTradesPage(),
        key: "NFT_TRADES",
        featured: [],
      },
      {
        name: "NFT Mints",
        to: routes.getLatestMintsPage(),
        key: "NFT_MINTS",
        featured: [],
      },
    ],
  },
  {
    name: "Accounts",
    icon: "wallet",
    to: routes.getAccountsPage(),
    activeRegex:
      /^\/accounts.*(transactions|internal-transactions|erc20|erc721|erc1155|contract-code)$/,
    key: "ACCOUNTS",
    featured: [],
  },
  {
    name: "Analytics",
    icon: "chart-bar",
    to: routes.getAnalyticsPage(),
    activeRegex: /^\/analytics.*(user|network|token|marketplace)$/,
    key: "ANALYTICS",
    featured: [],
  },
  {
    name: "Tokenomics",
    icon: "chart-pie",
    activeRegex: /^\/tokenomics.*$/,
    key: "TOKENOMICS",
    featured: ["NEW"],
    underItems: [
      {
        name: "Token Supply Dashboard",
        to: routes.getTokenSupplyDashboardPage(),
        key: "TOKEN_SUPPLY_DASHBOARD",
        featured: [],
      },
      {
        name: "Burn Dashboard",
        to: routes.getBurnDashboardPage(),
        key: "BURN_DASHBOARD",
        featured: ["NEW"],
      },
    ],
  },
  {
    name: "FAQ",
    icon: "question",
    to: "/faq",
    activeRegex: /^\/faq$/,
    key: "FAQ",
    featured: [],
  },
];
